import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './checklistItem.types';

export const checklistItemSelectors = {
  ...generateResourceSelectors<types.IChecklistItem>((state) => state.resource.checklistItem),
};
